module.exports = function(itemId, content) {
    this._sendMessage('saveForItem', {itemId: itemId, content: content});
};